import React, {  useState, useMemo } from "react";
import DeleteIcon from "../../../../assets/img/company/Vector.svg";
import { useDispatch, useSelector } from "react-redux";
import SubscriptionDialog from "../../company/company-edit-Dialog/SubscriptionDialog";
import { i18n } from "../../private/languageSelector";
import toast from "react-hot-toast";
import * as actions from "../../../../_redux/customers/customersActions";
import { useCustomersUIContext } from "../CustomersUIContext";
import CustomSearch from "../../../components/searchBar/CustomSearch";

function CustomerHeader({ searchValue, setSearchValue }) {
  const [showDeleteCustomerModal, setShowDeleteCustomerModal] = useState(false);
  const [showSearchInput, setShowSearchInput] = useState(false);
  const dispatch = useDispatch();
  const customersUIContext = useCustomersUIContext();
  const customersUIProps = useMemo(() => {
    return {
      ids: customersUIContext.ids,
      setIds: customersUIContext.setIds,
      queryParams: customersUIContext.queryParams,
      setQueryParams: customersUIContext.setQueryParams,
      openEditCustomerDialog: customersUIContext.openEditCustomerDialog,
      openDeleteCustomerDialog: customersUIContext.openDeleteCustomerDialog,
      openCustomerAddDialog: customersUIContext.newCustomerButtonClick,
    };
  }, [customersUIContext]);

  const handleSearchInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  const confirmDelete = () => {
    if (customersUIProps?.ids?.length) {
      dispatch(actions.deleteCustomers(customersUIProps?.ids)).then(() => {
        toast.success("Customers Deleted Successfully");
        customersUIProps.setIds([]);
      });
    } else {
      toast.error("No Customer Selected");
    }
    setShowDeleteCustomerModal(false);
  };
  const { language, user } = useSelector((state) => ({ language: state.auth?.language, user: state.auth?.user }));
  let dataCreationAccess = user && user?.rolePayload?.backOfficePayload[5]?.selected;
  let dataDeletionAccess = user && user?.rolePayload?.backOfficePayload[7]?.selected;

  return (
    <div className={`pl-4 pr-4 py-4 mb-3 d-flex justify-content-between align-items-center ${language === "arabic" ? "rtl" : "ltr"}`}>
      <CustomSearch
        handleSearchInputChange={handleSearchInputChange}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        showSearchInput={showSearchInput}
        setShowSearchInput={setShowSearchInput}
      />
      <div>
        {customersUIProps.ids?.length > 0 &&
          (dataDeletionAccess ? (
            <span className={` cursor-pointer ${language === "arabic" ? "ml-5" : "mr-5"} `} onClick={() => setShowDeleteCustomerModal(true)}>
              <img src={DeleteIcon} alt="Delete" />
            </span>
          ) : null)}
        {dataCreationAccess ? (
          <span className="add-text-btn" onClick={customersUIProps.openCustomerAddDialog}>
            {i18n("Customer.AddCustomer")}
          </span>
        ) : null}
      </div>
      <SubscriptionDialog
        show={showDeleteCustomerModal}
        onHide={() => setShowDeleteCustomerModal(false)}
        modalWidth="350px"
        modalHeight="185px"
        message={
          customersUIProps?.ids?.length === 1 ? i18n("Customer.AreYouSureToDeleteSingleCustomer") : i18n("Customer.AreYouSureToDeleteCustomers")
        }
        messageWidth="320px"
        messageHeight="44px"
        messageColor="#333333"
        messageFontWeight="400"
        messageFontSize="16px"
        messageLineHeight="21.79px"
        primaryAction={() => setShowDeleteCustomerModal(false)}
        primaryLabel={i18n("SubscriptionModals.CANCEL")}
        primaryLabelWidth="55px"
        primaryLabelHeight="20px"
        primaryLabelFontWeight="700"
        primaryLabelFontSize="14px"
        primaryLabelLineHeight="20px"
        primaryLabelColor="#828282"
        secondaryAction={confirmDelete}
        secondaryLabel={i18n("Discount.DELETE")}
        secondaryLabelWidth="67px"
        secondaryLabelHeight="20px"
        secondaryLabelFontWeight="700"
        secondaryLabelFontSize="14px"
        secondaryLabelLineHeight="20px"
        secondaryLabelColor="#EB5757"
        isCenteredOnMobile
      />
    </div>
  );
}

export default CustomerHeader;
